// extracted by mini-css-extract-plugin
module.exports = {"wrap_tabs":"styles_wrap_tabs__sDtP8","wrap_box":"styles_wrap_box__2z6ie"};